<ng-container *ngIf="asset">
  <div class="h-full flex sm:flex-grow-0 flex-grow-1 flex-column flex-nowrap lg:flex-row grid sm:mr-1">
    <div class="pl-4 col-12 lg:col-4 xl:col-2 h-fit">
      <ng-container *ngIf="loadedAsset; else assetLoading">
        <div class="flex flex-column">
          <div class="flex flex-row">
            <div class="align-self-center overflow-hidden">
              <h3
                #assetName
                [pTooltip]="asset.alias"
                [routerLink]="'/assets/' + asset.uuid + '/details'"
                [tooltipDisabled]="assetName.scrollWidth <= assetName.offsetWidth"
                class="cursor-pointer overflow-hidden text-overflow-ellipsis"
                tooltipPosition="top"
              >
                {{ asset.alias }}
              </h3>
            </div>
            <div class="align-self-center h-full">
              <button
                [routerLink]="'/assets/' + asset.uuid + '/details'"
                class="p-button-link p-button-lg align-self-center pb-4 ml-1"
                icon="pi pi-external-link"
                iconPos="right"
                pButton
              ></button>
            </div>
          </div>
          <p><i [ngStyle]="{backgroundColor: statusColor}" aria-hidden="true" class="asset-status"></i>
            {{ 'misc.status' | transloco:{status: (('misc.representation.' + (status?.toLowerCase() ?? 'default')) | transloco)} }}
          </p>
          <p>{{ asset.tenant.name }}</p>
          <p>{{ asset.description ? asset.description : 'empty.description' | transloco }}</p>
          <div class="mt-2 pb-2">
            <p-dropdown
              (onChange)="dateChanged($event)"
              [disabled]="!measurementView.selected"
              [options]="timeOptions"
              [style.opacity]="measurementView.selected ? '100%' : 0"
              appendTo="body"
              styleClass="w-full "
            ></p-dropdown>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="flex flex-column flex-grow-1 col-12 lg:col-8 xl:col-10 pb-0">
      <p-tabView class="custom-tabView flex flex-grow-1"
                 styleClass=" flex flex-column flex-grow-1 w-full h-full custom-tabView">
        <p-tabPanel
          #measurementView
          [class]="'flex flex-column flex-grow-1 w-full custom-tabView-panel ' + (measurementView.selected ? 'h-full': '')"
          [header]="'misc.assetDetails.measurements' | transloco" leftIcon="pi pi-chart-bar">

          <ng-template class="w-full h-full" pTemplate="content">
            <ng-container *ngIf="loadedAssetMeasurements && loadedAssetDeviceMeasurements; else loadingContent">
              <p-carousel
                *ngIf="measurements.length > 0"
                [numScroll]="3"
                [numVisible]="3"
                [responsiveOptions]="
          [
            { breakpoint: '1200px', numVisible: 2, numScroll: 2 },
            { breakpoint: '900px', numVisible: 1, numScroll: 1 }
          ]"
                [showIndicators]="false"
                [value]="measurements"
                styleClass="max-w-full"
              >
                <ng-template let-measurement pTemplate="item">
                  <div class="flex" style="height: 64px;">
                    <div
                      (click)="loadMeasuresIfChanged(measurement); selectedMeasurement = measurement"
                      [class.measurement-card-selected]="measurement==selectedMeasurement"
                      class="flex flex-1 measurement-card"
                    >
                      <div class="flex" style="width: 25px;">
                        <i
                          *ngIf="measurement.type === 'ASSET'"
                          class="pl-1 align-self-center pi pi-map-marker"
                          style="font-size: 23px;"
                        ></i>
                        <i
                          *ngIf="measurement.type === 'DEVICE'"
                          class="pl-1 align-self-center pi pi-mobile"
                          style="font-size: 23px;"
                        ></i>
                      </div>
                      <div class="flex flex-1 justify-content-between">
                        <div *ngIf="measurement.type === 'ASSET'" class="flex">
                          <p class="pl-3 align-self-center bold">{{ measurement.name }}</p>
                        </div>
                        <div *ngIf="measurement.type === 'DEVICE'" class="flex flex-column">
                          <p class="pl-3 mb-0 bold">{{ measurement.alias || measurement.name }}</p>
                          <p
                            class="pl-3 mb-0">{{ measurement.deviceSerialNumber ? measurement.deviceSerialNumber : '' }}</p>
                        </div>
                        <div *ngIf="measurement.lastValue" class="flex flex-column">
                          <div class="flex align-items-end justify-content-end text-right">
                            <p class="pl-3 mb-0 text-xl capitalize">{{ measurement.lastValue }}</p>
                            <p class="ml-1"
                               style="margin-bottom: 2px;"> {{ measurement.unit ? measurement.unit : '' }}</p>
                          </div>
                          <p
                            class="pl-3 mb-0 text-sm capitalize">{{ measurement.lastValueDate | customDate: ({showTimezone: true}) }}</p>
                        </div>

                        <div *ngIf="!measurement.lastValue"
                             class="flex align-items-center justify-content-end text-right">
                          <p class="pl-3 text-black-alpha-60">{{ 'empty.measures' | transloco }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </p-carousel>
              <app-generic-graph
                *ngIf="chartMeasures && chartMeasures.length > 0"
                [customSeries]="true"
                [data]="chartMeasures"
                [height]="205"
                [yAxis]="graphAxis"
                chartType="spline"
                class="mt-3"
                name="Value"
                tooltipDateFormat="%A, %e %b %Y, %H:%M:%S %Z"
                tooltipDecimalPlaces="3"
              ></app-generic-graph>
              <div *ngIf="chartMeasures.length == 0" class="flex h-full justify-content-center">
                <p class="align-self-center text-2xl font-italic">{{ 'empty.measures' | transloco }}</p>
              </div>
            </ng-container>
          </ng-template>

        </p-tabPanel>
        <p-tabPanel
          #triggerView
          [class]="'flex flex-column flex-grow-1 w-full custom-tabView-panel ' + (triggerView.selected ? 'h-full': '')"
          [header]="'misc.assetDetails.activatedTriggers' | transloco"  leftIcon="pi pi-exclamation-triangle">

          <ng-template class="w-full h-full" pTemplate="content">
            <ng-container *ngIf="loadedAssetTriggers; else loadingContent">
              <p-carousel
                *ngIf="triggersCarousel.length > 0"
                [numScroll]="3"
                [numVisible]="3"
                [responsiveOptions]="
          [
            { breakpoint: '1200px', numVisible: 2, numScroll: 2 },
            { breakpoint: '900px', numVisible: 1, numScroll: 1 }
          ]"
                [showIndicators]="false"
                [value]="triggersCarousel"
                styleClass="max-w-full"
              >
                <ng-template let-status pTemplate="item">
                  <div class="flex flex-row" style="height: 64px;">
                    <div
                      (click)="setSelectedStatus(status.status)"
                      [class.measurement-card-selected]="status.status===selectedStatusCategory"
                      class="flex flex-1 measurement-card align-content-center align-items-center gap-2"
                    >
                      <div class="flex" style="width: 25px;">
                        <i
                          *ngIf="status.status === 'ALARM'"
                          class="pl-1 align-self-center pi pi-exclamation-triangle"
                          style="font-size: 23px;"
                        ></i>
                        <i
                          *ngIf="status.status === 'WARNING'"
                          class="pl-1 align-self-center pi pi-exclamation-circle"
                          style="font-size: 23px;"
                        ></i>
                        <i
                          *ngIf="status.status === 'INACTIVITY'"
                          class="pl-1 align-self-center pi pi-wifi"
                          style="font-size: 23px;"
                        ></i>
                      </div>
                      <div
                        class="flex flex-1 justify-content-between h-full align-content-center align-items-center gap-4">
                        <p
                          class="pl-3 mb-0 capitalize font-bold">{{ 'misc.representation.' + status.status.toLowerCase() | transloco }}</p>
                        <div class="flex flex-1 justify-content-end h-full align-content-center align-items-center">
                          <p class="pr-3 text-xl mb-0"> {{ 'misc.representation.state.enabled' | transloco }}
                            : {{ status.count }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </p-carousel>
              <ng-container>
                <ng-container
                  *ngTemplateOutlet="triggerContent; context: { $implicit: selectedStatus ?? triggersByStatus?.alarmTriggers }">
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-template>

        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
  <ng-template #loadingContent>
    <p-skeleton [height]="'100%'" [width]="'100%'" class="h-full flex flex-grow-1 mt-1"></p-skeleton>
  </ng-template>

  <ng-template #assetLoading>
    <p-skeleton [height]="'29.39px'" styleClass="mb-3 w-full"></p-skeleton>
    <p-skeleton [height]="'21px'" styleClass="mb-3 w-full"></p-skeleton>
    <p-skeleton [height]="'21px'" styleClass="mb-3 w-full"></p-skeleton>
    <p-skeleton [height]="'21px'" styleClass="mb-3 w-full"></p-skeleton>
    <div *ngIf="measurementView.selected" class="mb-4 pb-2">
      <div class="mt-2">
        <p-skeleton [height]="'31px'" styleClass="mb-0 w-full"></p-skeleton>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #triggerContent let-item>
  <ng-container *ngIf="item.length === 0">
    <div class="flex h-full justify-content-center">
      <p class="align-self-center text-2xl font-italic">{{ 'empty.triggers' | transloco }}</p>
    </div>
  </ng-container>
  <ng-container *ngIf="item.length !== 0">
    <p-table
      [autoLayout]="true"
      [columnResizeMode]="'fit'"
      [first]="0"
      [paginator]="true"
      [responsiveLayout]="'stack'"
      [responsive]="true"
      [rows]="4"
      [totalRecords]="item.length"
      [value]="item"
      styleClass="p-datatable-striped"
    >
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">{{ "attribute.name" | transloco }}</th>
          <th scope="col">{{ "attribute.entityType" | transloco }}</th>
          <th scope="col">{{ "attribute.condition" | transloco }}</th>
          <th scope="col">{{ 'attribute.measurementName' | transloco }}</th>
          <th scope="col">{{ 'attribute.valueEvaluated' | transloco }}</th>
        </tr>
      </ng-template>
      <ng-template let-trigger pTemplate="body">
        <tr>
          <td>
            <span class="p-column-title bold">{{ 'attribute.name' | transloco }}</span>
            <a
              *ngIf="trigger.entityType === 'DEVICE'"
              [routerLink]="'/devices/'+trigger.device.uuid+'/details'"
              [state]="{showView: 'events', trigger: trigger}"
            >{{trigger.name}}</a>
            <a
              *ngIf="trigger.entityType === 'ASSET'"
              [routerLink]="'/assets/'+trigger.asset.uuid+'/details'"
              [state]="{showView: 'events', trigger: trigger}"
            >{{trigger.name}}</a>
          </td>
          <td>
            <span class="p-column-title bold">{{ 'attribute.entityType' | transloco }}</span>
            <p *ngIf="trigger.entityType === 'DEVICE'">{{ 'model.device' | transloco }}</p>
            <p *ngIf="trigger.entityType === 'ASSET'">{{ 'model.asset' | transloco }}</p>
          </td>
          <td>
            <span class="p-column-title bold">{{ 'attribute.condition' | transloco }}</span>
            <p-tag severity="info" value="{{trigger.type}}({{trigger.expression}})"></p-tag>
          <td>
            <span class="p-column-title bold">{{ 'attribute.measurementName' | transloco }}</span>
            <p *ngIf="trigger.entityType === 'DEVICE'">{{trigger.deviceMeasurement ? trigger.deviceMeasurement.name : ''}}</p>
            <p *ngIf="trigger.entityType === 'ASSET'">{{trigger.assetMeasurement ? trigger.assetMeasurement.name : ''}}</p>
        </td>
          <td>
            <span class="p-column-title bold">{{ 'attribute.valueEvaluated' | transloco }}</span>
            {{ trigger.lastValueEvaluated }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
</ng-template>
